"use client"

import * as React from "react"
import { format } from "date-fns"
import { CalendarIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button } from "@/Components/ui/button"
import { Calendar } from "@/Components/ui/calendar"
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/Components/ui/popover"
import { dateformat } from "@/utils/GlobalConstants"

interface DatePickerProps {
    date: Date
    setDate: React.Dispatch<React.SetStateAction<Date>>
    disable?: boolean
    ghost?: boolean
    className?: string
}

function DatePicker({ date, setDate, disable, ghost = false, className = "" }: DatePickerProps) {
    if (ghost) {
        const [openState, setOpenState] = React.useState(false);

        return (
            <Popover open={openState} onOpenChange={setOpenState}>
                <PopoverTrigger asChild>
                    <button
                        className={cn(
                            className,
                            "bg-transparent outline-none text-left focus:outline-solid",
                            !date && "text-muted-foreground"
                        )}
                        onClick={(e) => { e.stopPropagation(); }}
                        disabled={disable}
                    >
                        {date ? format(date, dateformat) : <span>Pick a date</span>}
                    </button>
                </PopoverTrigger>
                <PopoverContent onClick={(e) => { e.stopPropagation(); }} className="w-auto p-0">
                    <Calendar
                        className="pointer-events-auto"
                        mode="single"
                        selected={date}

                        onSelect={(day) => { setDate(day as Date); setOpenState(!openState); }}
                        initialFocus
                        weekStartsOn={1}
                    />
                </PopoverContent>
            </Popover>
        )
    }
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant={"outline"}
                    className={cn(
                        className,
                        "justify-start text-left font-normal bg-card",
                        !date && "text-muted-foreground"
                    )}
                    disabled={disable}
                >
                    <CalendarIcon />
                    {date ? format(date, dateformat) : <span>Pick a date</span>}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0">
                <Calendar
                    className="pointer-events-auto"
                    mode="single"
                    selected={date}
                    onSelect={(day) => setDate(day as Date)}
                    initialFocus
                    weekStartsOn={1}
                />
            </PopoverContent>
        </Popover>
    )
}

export default DatePicker;